import React, { FC } from "react";

import { useBasketShare } from "@keepeek/commons";
import { KModalContentSection, withSuspense } from "@keepeek/refront-components";
import { DatePicker } from "@mui/lab";
import AdapterDayjs from "@mui/lab/AdapterDayjs";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import logger from "../../../lib/logger-utils";
import { configSectionComponentBasketSelector } from "../../../providers/config/selectors";
import { useCurrentLocale } from "../../../providers/i18n/hooks";

import { CommonBasketShareProps } from "./index";

const PublicShareDeactivationDate: FC<CommonBasketShareProps> = function ({
  basketId,
  sentryCallback,
  snackbarCallback,
}) {
  const { t } = useTranslation();
  const { displayBackofficeSharedBasket } = useRecoilValue(
    configSectionComponentBasketSelector,
  ) ?? {
    displayBackofficeSharedBasket: undefined,
  };
  const { selectedDeactivationDate, setSelectedDeactivationDate } = useBasketShare(
    displayBackofficeSharedBasket ?? false,
    basketId,
    sentryCallback,
    snackbarCallback,
  );
  const currentLocale = useCurrentLocale();
  return (
    <KModalContentSection
      title={t("basket.share.content.deactivation-date.title")}
      description={t("basket.share.content.deactivation-date.description")}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={selectedDeactivationDate.active}
            onChange={(e) =>
              setSelectedDeactivationDate((currVal) => ({ ...currVal, active: e.target.checked }))
            }
          />
        }
        label={t("basket.share.content.deactivation-date.checkbox.label").toString()}
      />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={currentLocale || "fr"}>
        <DatePicker
          value={selectedDeactivationDate.date && dayjs(selectedDeactivationDate.date)}
          inputFormat={t("input.date.format") as string}
          onChange={(date) => {
            if (date) {
              try {
                const isoDate = date.hour(0).minute(0).second(0).toISOString();
                setSelectedDeactivationDate((currVal) => ({
                  ...currVal,
                  active: true,
                  date: isoDate,
                }));
              } catch (err) {
                setSelectedDeactivationDate((currVal) => ({
                  ...currVal,
                  active: false,
                }));
                logger.debug("date is not valid");
              }
            } else {
              setSelectedDeactivationDate((currVal) => ({
                ...currVal,
                active: false,
              }));
            }
          }}
          renderInput={(inputProps) => (
            <TextField
              id="PublicShareDeactivationDateInput"
              aria-label={t("basket.share.content.deactivation-date.input.label") as string}
              {...inputProps}
              autoComplete={"off"}
              variant="standard"
              sx={{ "& input": { padding: "10px 0px 0px" } }}
            />
          )}
        />
      </LocalizationProvider>
    </KModalContentSection>
  );
};

export default withSuspense(PublicShareDeactivationDate);
